import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import TranslationProvider from '../../providers/TranslationProvider';
import containerQueryProps from '../../props/containerQueryProps';

import './Auth.scss';
import InputCode from '../Account/UpdatePhone/InputCode';
import Button from '../Button';
import parsePhone from '../../utils/parsePhone';
import { AuthFlowType } from '../../containers/AuthContainer/authSteps';

const VerifyCodeView = ({
  onSubmit,
  onResendCode,
  onHelpClick,
  phone,
  containerQuery,
  maskedEmail,
  errorMessage,
  authFlowType,
  processing,
}) => {
  const { sm } = containerQuery;

  const renderCopy = () => {
    if (maskedEmail) {
      return (
        <div
          role="alert"
        >
          <TranslationProvider
            translationKey="onboarding.code_title_email"
          >
            <div className="AuthView__Text--bold AuthView__Help--Title">
              Check your email!
            </div>
          </TranslationProvider>
          <div
            className="AuthView__Text--light AuthView__Help--Copy"
          >

            <TranslationProvider
              translationKey="onboarding.code_copy_no_password"
            >
              <div>
                No need for a password.
              </div>
            </TranslationProvider>
            <div>
              <TranslationProvider
                translationKey="onboarding.code_copy_one"
              >
                <span>We sent a 6-digit confirmation code to </span>
              </TranslationProvider>
              <span className="AuthView__Text--email">
                {maskedEmail}
              </span>
              <span>.</span>
            </div>
          </div>
        </div>
      );
    }
    const phoneObj = parsePhone(phone);

    return (
      <div
        role="alert"
      >
        <TranslationProvider
          translationKey="onboarding.code_title"
        >
          <div className="AuthView__Text--bold VerifyCodeViewTitle">
            Check your mobile phone!
          </div>
        </TranslationProvider>
        {authFlowType !== AuthFlowType.VERIFY_PHONE_TO_SIGN_UP && (
        <TranslationProvider translationKey="onboarding.code_copy_no_password">
          <div>
            No need for a password.
          </div>
        </TranslationProvider>
        )}
        <div
          className="AuthView__Text--light VerifyCodeViewTextDesc"
        >
          <TranslationProvider
            translationKey="onboarding.code_copy_one"
          >
            <span>We sent a 6-digit confirmation code to </span>
          </TranslationProvider>
          <span className="AuthView__Text--phone">
            {`+${phoneObj.countryCode} ${phoneObj.nationalFormat}`}
          </span>
          <span>.</span>
        </div>
      </div>
    );
  };

  return (
    <div
      className={cx('AuthView', {
        'AuthView--sm': sm,
      })}
    >
      {renderCopy()}
      <InputCode
        onComplete={onSubmit}
        processing={processing}
        error={errorMessage}
        onResend={onResendCode}
      />
      {!processing && (
      <div
        className={cx('AuthView__Footer VerifyCodeViewFooter', {
          'AuthView__Footer--sm': sm,
        })}
      >
        <TranslationProvider
          translationKey="onboarding.need_help"
        >
          <Button
            onClick={onHelpClick}
            type="button"
            variant="link"
            className="HelpButton"
            id="help-button"
          >
            Need Help?
          </Button>
        </TranslationProvider>
      </div>
      )}
    </div>
  );
};

VerifyCodeView.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onResendCode: PropTypes.func.isRequired,
  onHelpClick: PropTypes.func.isRequired,
  phone: PropTypes.string.isRequired,
  containerQuery: containerQueryProps,
  maskedEmail: PropTypes.string,
  errorMessage: PropTypes.string,
  authFlowType: PropTypes.string,
  processing: PropTypes.bool,
};

VerifyCodeView.defaultProps = {
  containerQuery: {},
  maskedEmail: null,
  errorMessage: null,
  processing: false,
  authFlowType: AuthFlowType.DEFAULT,
};

VerifyCodeView.displayName = 'VerifyCodeView';

export default VerifyCodeView;
